import React, {useState} from "react";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import styled from 'styled-components';

const Item = styled.div`
  cursor: pointer;
  width: 100%;
`;

const LightboxGallery = ({items, layout}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const mainSrc = items[index].props.photo.staticPath;
  const nextSrc = items[(index + 1) % items.length].props.photo.staticPath;
  const prevSrc = items[(index + items.length - 1) % items.length].props.photo.staticPath;
  const moveNext = () => setIndex((index + 1) % items.length);
  const movePrev = () => setIndex((index + items.length - 1) % items.length);
  const openInLightbox = (index) => {
    setIndex(index);
    setIsOpen(true);
  };

  return (
    <>
      {isOpen && (
        <>
          <Lightbox
            mainSrc={mainSrc}
            nextSrc={nextSrc}
            prevSrc={prevSrc}
            onMovePrevRequest={movePrev}
            onMoveNextRequest={moveNext}
            onCloseRequest={() => setIsOpen(false)}
            enableZoom={false}
            wrapperClassName="ITFLightbox"
          />
        </>
      )}
      {React.cloneElement(layout, {items: React.Children.map(items, (child, index) => <Item onClick={() => openInLightbox(index)}>{child}</Item>)})}
    </>
  )
};

export default LightboxGallery;